import { render, staticRenderFns } from "./delivery-v2.vue?vue&type=template&id=3ff732ff&scoped=true&"
import script from "./delivery-v2.vue?vue&type=script&lang=js&"
export * from "./delivery-v2.vue?vue&type=script&lang=js&"
import style0 from "./delivery-v2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./delivery-v2.vue?vue&type=style&index=1&id=3ff732ff&scoped=true&lang=scss&"
import style2 from "./delivery-v2.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff732ff",
  null
  
)

export default component.exports